import { render } from "./AcceptInitiative.vue?vue&type=template&id=4b6a9cbd"
import script from "./AcceptInitiative.vue?vue&type=script&lang=js"
export * from "./AcceptInitiative.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__